const baseUrl = process.env.VIXIO_BACKEND || "http://pc.loc:8005";

export default {
  // Set ssr to false for client side (SPA) rendering
  ssr: true,
  buildDir: ".nuxt",
  server: {
    port: process.env.VIXIO_PORT || 65481,
    host: process.env.VIXIO_LISTEN_HOST || "localhost",
  },
  env: {
    CLIENT_URL: process.env.VIXIO_CLIENT_URL || "http://localhost:65481",
    BASE_URL: baseUrl,
    PRODUCT_VERTICAL: process.env.VIXIO_PRODUCT_VERTICAL || "payments_compliance",
    // JSON_API_URL: `${process.env.BASE_URL}/jsonapi`,
    // API_URL: `${process.env.BASE_URL}/api`,
    // VIXIO_AUTH_URL:  process.env.VIXIO_API_SERVER || "https://stage.api.vixio.support",
    // VIXIO_API_URL: `${process.env.VIXIO_API_SERVER || "https://stage.api.vixio.support"}/api/pc`,
    // ECS_API_URL: `${process.env.ECS_API_URL}`,

    // ECS_ELASTIC_INDEX: `${process.env.ECS_ELASTIC_INDEX}`,
    // ECS_TAX_INDEX: `${process.env.ECS_TAX_INDEX}`,
    // ECS_API_AUTH_KEY: `${process.env.ECS_API_AUTH_KEY}`,

    CLIENT_ID: "6294b2ad-736a-4cf4-9b24-dd510537c14d",
    CLIENT_SECRET: "3e3356f12a",
    TOKEN_COOKIE_DOMAIN: process.env.TOKEN_COOKIE_DOMAIN || "pc-project.loc",
    TOKEN_COOKIE_SECURE: process.env.TOKEN_COOKIE_SECURE || false,
    TOKEN_COOKIE_HTTP_ONLY: process.env.TOKEN_COOKIE_HTTP_ONLY || false,

    // VIXIO_API_EMAIL: `${process.env.VIXIO_API_EMAIL}`,
    // VIXIO_API_PASSWORD: `${process.env.VIXIO_API_PASSWORD}`
  },

  publicRuntimeConfig: {
    clientURL: process.env.VIXIO_CLIENT_URL || "http://localhost:65481",
    baseURL: baseUrl,
    apiURL: process.env.VIXIO_PRODUCT_VERTICAL ? `${baseUrl}/api/${process.env.VIXIO_PRODUCT_VERTICAL}` : `${baseUrl}/api/payments_compliance`,
    jsonApiURL: `${baseUrl}/jsonapi`,
    ecsApiURL: process.env.ECS_API_URL || "http://es.pc.loc:8005",
    ecsElasticIndex:
      process.env.ECS_ELASTIC_INDEX ||
      "elasticsearch_index_drupal_global_search",
    ecsTaxIndex:
      process.env.ECS_TAX_INDEX || "elasticsearch_index_drupal_taxonomy",
    matomoURL: process.env.MATOMO_URL || "https://analytics.vixio.support",
    matomoSiteId: process.env.MATOMO_SITE_ID || 2,
    matomoPageViewDataDimension:
      process.env.MATOMO_PAGE_VIEW_DATA_DIMENSION || 5,
    churnZeroAppKey: process.env.CHURNZERO_APP_KEY || "1!1C86B8iNRbueeCfegQi04lWJgM1xQtpHRMs1qU3CpHIt14D5",
    churnZeroEndpoint: process.env.CHURNZERO_ENDPOINT || "https://vixio-dev.eu1app.churnzero.net/churnzero.js",
    churnZeroEnabled: process.env.CHURNZERO_ENABLED || false,
    workspaceFEURL: process.env.WORKSPACE_FE_URL || "https://ws-staging.vixio.support",
    financialServicesFEURL: process.env.FINANCIAL_SERVICES_FE_URL || "https://fs.vixio.com/",
    // Feature flags. Default OFF in production unless env says otherwise.
    // Read in components via this.$config.features.<name>.
    features: {
      // New homepage (feed-based with filters, replaces old static homepage).
      newHomepage: process.env.FEATURE_NEW_HOMEPAGE === "true",
      // New search (Skywalker semantic search with refinements + facets).
      newSearch: process.env.FEATURE_NEW_SEARCH === "true",
      // VIQ AI assistant (replaces Pickaxe widget when enabled).
      viq: process.env.FEATURE_VIQ === "true",
      // VIQ sub-features (only meaningful if viq is enabled).
      viqLenses: process.env.FEATURE_VIQ_LENSES === "true",
      viqActOn: process.env.FEATURE_VIQ_ACT_ON === "true",
      viqShare: process.env.FEATURE_VIQ_SHARE === "true",
    },
  },

  privateRuntimeConfig: {
    ecsApiAuthKey: process.env.ECS_API_AUTH_KEY,
    clientId: process.env.CLIENT_ID,
    clientSecret: process.env.CLIENT_SECRET,
  },

  // Global page headers: https://go.nuxtjs.dev/config-head
  head: {
    title: "payments",
    htmlAttrs: {
      lang: "en",
    },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { hid: "description", name: "description", content: "" },
      { name: "format-detection", content: "telephone=no" },
    ],
    link: [{ rel: "icon", href: "/favicon.png" }],
  },

  loading: "components/elements/Loading",

  // Global CSS: https://go.nuxtjs.dev/config-css
  css: [
    "@/assets/styles/style.scss",
    "@/assets/styles/plugins/elementTheme.scss",
  ],

  // Plugins to run before rendering page: https://go.nuxtjs.dev/config-plugins
  plugins: [
    "@/plugins/axios",
    "@/plugins/element-ui",
    { src: "~/plugins/hotjar", mode: "client", ssr: false },
    { src: "~/plugins/vue-awesome-swiper", mode: "client", ssr: false },
    { src: "~/plugins/vue-matomo.js", ssr: false },
    { src: "~/plugins/churn-zero.js", ssr: false },
    { src: "~/plugins/pageView.js" },
    { src: "~/plugins/impersonation.js", mode: "client", ssr: false },
  ],

  // Auto import components: https://go.nuxtjs.dev/config-components
  components: ["~components", "~components/elements"],

  // Modules for dev and build (recommended): https://go.nuxtjs.dev/config-modules
  buildModules: [
    // https://go.nuxtjs.dev/eslint
    "@nuxtjs/eslint-module",
    "@nuxtjs/google-analytics",
  ],

  styleResources: {
    scss: ["./assets/styles/helpers/variables.scss"],
  },

  // Modules: https://go.nuxtjs.dev/config-modules
  modules: [
    // https://go.nuxtjs.dev/axios
    "@nuxtjs/axios",
    "cookie-universal-nuxt",
    "@nuxtjs/router-extras",
    "nuxt-leaflet",
    "nuxt-highcharts",
    "@nuxtjs/sentry",
  ],
  sentry: {
    dsn: process.env.SENTRY_DSN || "https://d50cb0bbb3a6ff02d4cb211b1b291c5f@o4508375391469568.ingest.de.sentry.io/4508737942388816",
    clientIntegrations: {
        Replay: {},
    },
    clientConfig: {
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        maskAllText: false,
        blockAllMedia: false
    }
},
  // Axios module configuration: https://go.nuxtjs.dev/config-axios
  axios: {},

  googleAnalytics: {
    id: "UA-25448550-14",
  },

  serverMiddleware: ["~/api/index.js"],
  // Build Configuration: https://go.nuxtjs.dev/config-build
  build: {
    loaders: {
      scss: {
        sassOptions: {
          quietDeps: true,
        },
      },
    },
    extractCSS: true,
    vendor: ["axios", "babel-polyfill"],
    transpile: [/^element-ui/],
    extend(config, ctx) {
      if (ctx.isDev) {
        config.devtool = ctx.isClient ? "source-map" : "inline-source-map";
      }
    },
  },
};
